import {useState} from 'react';
import type {ViewTypes} from '../common/types';

const storageKey = `entry`;

export function useEntry(): [
  ViewTypes | null,
  (view: ViewTypes | null) => void,
] {
  const [entry, setEntry] = useState<ViewTypes | null>(
    sessionStorage.getItem(storageKey) as ViewTypes | null,
  );

  const set = (view: ViewTypes | null) => {
    if (view === null) {
      sessionStorage.removeItem(storageKey);
    } else {
      sessionStorage.setItem(storageKey, view);
      setEntry(view);
    }
  };

  return [entry, set];
}
